import { Select, SelectProps } from "antd";
import { useEffect, useMemo } from "react";
import { httpRequest } from "../../helpers/api";
import { renderEmployeeCodeOrTemp } from "../../helpers/employee";
import { generateQueryString } from "../../helpers/generateQueryString";
import { IQuery } from "../../helpers/pagination";
import { BaseResponsePaginationProps } from "../../types/config.type";
import { ListUserQuery, UserProperties } from "../../types/user.type";

interface Props extends SelectProps {
	officeId?: string | string[];
	userList: UserProperties[];
	setUserList: React.Dispatch<React.SetStateAction<UserProperties[]>>;
	customQuery?: IQuery<ListUserQuery>;
	excludeUserId?: string | string[];
	isLabelWithOffice?: boolean;
}
const SelectEmployee: React.FC<Props> = ({
	officeId,
	userList,
	setUserList,
	customQuery,
	excludeUserId,
	isLabelWithOffice,
	...rest
}) => {
	const _handleSearchUser = async (query: string) => {
		let Query: IQuery<ListUserQuery> = {
			includeData: "profile,employeeOffice",
			filterRoleApprovalStatus: "APPROVED",
			filterStatus: "ACTIVE",
			search: query,
			limit: 20,
			offset: 0,
			filterOfficeId: Array.isArray(officeId) ? (officeId as string[]).join(",") : officeId,
			...customQuery,
		};

		let url = "users" + generateQueryString(Query);
		const { data } = await httpRequest.get<BaseResponsePaginationProps<UserProperties>>(url);
		setUserList(data.payload.results);
	};

	const filteredUser = useMemo(() => {
		if (excludeUserId) {
			if (excludeUserId instanceof Array) {
				return userList.filter((item) => !excludeUserId.includes(item.userId));
			} else {
				return userList.filter((item) => item.userId !== excludeUserId);
			}
		}
		return userList;
	}, [userList, excludeUserId]);

	return (
		<Select
			virtual={false}
			placeholder="Choose Agent or Staff"
			disabled={!officeId}
			showSearch
			defaultActiveFirstOption={false}
			filterOption={false}
			onSearch={_handleSearchUser}
			notFoundContent={null}
			options={filteredUser.map((row) => ({
				value: row.userId,
				label: `${row.nickName?.toUpperCase()} ${
					isLabelWithOffice ? `/ ${row?.employee?.[0].office?.officeName}` : ""
				} / ${renderEmployeeCodeOrTemp(row.employee?.[0])}`,
			}))}
			{...rest}
		/>
	);
};
export default SelectEmployee;
